/**
 * Défini le fetching d'une ressource
 * @type {string}
 */
export const USER_AGENCY_SET_FETCHING = 'setFetching'

/**
 * Met à jours les informations sur les AgentRequest non lues
 * @type {string}
 */
export const USER_AGENCY_AGENT_REQUEST_UNREAD = 'setAgentRequestUnread'

/**
 * Défini le pricing de l'agence
 * @type {string}
 */
export const USER_AGENCY_SET_PRICING = 'setPricing'

/**
 * Défini les agences exploitables
 * @type {string}
 */
export const USER_AGENCY_SET_AGENCIES = 'setAgencies'

/**
 * Insère / met à jour une agence
 * @type {string}
 */
export const USER_AGENCY_SET_AGENCY = 'setAgency'

/**
 * Défini le sites exploitables par l'utilisateur
 * @type {string}
 */
export const USER_AGENCY_SET_SITES = 'setSites'

/**
 * Insère / met à jour un site de l'agence
 * @type {string}
 */
export const USER_AGENCY_SET_SITE = 'setSite'

/**
 * Supprime un site de l'agence
 * @type {string}
 */
export const USER_AGENCY_DELETE_SITE = 'deleteSite'

/**
 * Défini les agents exploitables dans l'appli
 * @type {string}
 */
export const USER_AGENCY_SET_AGENTS = 'setAgents'

/**
 * Insère / met à jour un agent de l'agence
 * @type {string}
 */
export const USER_AGENCY_SET_AGENT = 'setAgent'

/**
 * Supprimer un agent de l'agence
 * @type {string}
 */
export const USER_AGENCY_DELETE_AGENT = 'deleteAgent'

/**
 * Défini les clients exploitables dans l'appli
 * @type {string}
 */
export const USER_AGENCY_SET_CLIENTS = 'setClients'

/**
 * Insère / met à jour un client de l'agence
 * @type {string}
 */
export const USER_AGENCY_SET_CLIENT = 'setClient'

/**
 * Supprimer un client de l'agence
 * @type {string}
 */
export const USER_AGENCY_DELETE_CLIENT = 'deleteClient'

/**
 * Défini les rondes dans l'appli
 * @type {string}
 */
export const USER_AGENCY_SET_RONDES = 'setRondes'

/**
 * Met à jour une ronde de l'appli
 * @type {string}
 */
export const USER_AGENCY_SET_RONDE = 'setRonde'

/**
 * Supprimer une ronde dans l'appli
 * @type {string}
 */
export const USER_AGENCY_DELETE_RONDE = 'deleteRonde'

/**
 * Défini les checkpoints dans l'appli
 * @type {string}
 */
export const USER_AGENCY_SET_CHECKPOINTS = 'setCheckpoints'

/**
 * Défini un checkpoint dans l'appli
 * @type {string}
 */
export const USER_AGENCY_SET_CHECKPOINT = 'setCheckpoint'

/**
 * Supprimer un checkpoint dans l'appli
 * @type {string}
 */
export const USER_AGENCY_DELETE_CHECKPOINT = 'deleteCheckpoint'
